module.exports = __webpack_public_path__ + "img/general-electric-2x_ea117d29eebb83d45382a15908904aaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/general-electric-2x.jpg
// module id = 274
// module chunks = 0